export const LicenseTypes = {
  DEA: 'DEA',
  DVM: 'DVM',
  OTHER: 'Other',
}
